<template>
  <div class="sidebar right fixed" :class="{'active': active, 'inactive': hideme}">
    <div class="fixed-container">
      <!-- Begin Header -->
      <div class="grid-x toolbar header">
        <div class="cell">
          <div class="select-container">
            <select v-model="selectedView">
              <option value="">Objekter i kontrakt {{kontrakt.Kontraktnr}}</option>
              <option value="search">Søk i alle objekter</option>
            </select>
            <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
          </div>
        </div>

        <a href="javascript:;" @click="closeSidebar()" class="modal-window-close-button modal-window-sidebar-close-button"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
      </div>
      <!-- End Header -->

      <KundeKontraktObjektSidebarObjektlist v-show="selectedView !== 'search'" :kunde="kunde" :kontrakt="kontrakt" :objekt="objekt"/>
      <KundeKontraktObjektSidebarSearch v-show="selectedView === 'search'" :kunde="kunde" :kontrakt="kontrakt" :objekt="objekt"/>
    </div>

    <div class="sidebar-overlay" @click="closeSidebar()"></div>
  </div>
</template>

<script>
import KundeKontraktObjektSidebarObjektlist from './KundeKontraktObjektSidebarObjektlist'
import KundeKontraktObjektSidebarSearch from './KundeKontraktObjektSidebarSearch'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektSidebar',
  components: {
    KundeKontraktObjektSidebarObjektlist,
    KundeKontraktObjektSidebarSearch
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    hideme: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      selectedView: ''
    }
  },
  mounted () {
    // Listen to submit form event from parent - cus button is in parent
  },
  created () {
    // Must turn off the event listener in case it is already there...
  },
  methods: {
    closeSidebar: function () {
      bus.$emit('close-objekt-sidebar')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektSidebar.vue